module.exports = __webpack_public_path__ + "img/2Reihe_2.cd4d86ee.jpg";